<template>
	<transition name="fade">
		<button
			v-if="visible"
			@click="scrollToTop"
			class="back-to-top"
			:class="{ 'cart-visible': isCartButtonVisible }"
		/>
	</transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'BackToTopButton',

	props: {
		scrollTarget: {
			type: String,
			default: null
		},
		scrollThreshold: {
			type: Number,
			default: 100
		},
		offset: {
			type: Number,
			default: 80
		}
	},

	data() {
		return {
			visible: false
		}
	},

	computed: {
		...mapState('venue', ['venueInfo']),
		...mapGetters('cart', ['isTabOpened', 'totalProductsCount']),

		isCartButtonVisible() {
			return (
				this.acceptOnlineOrder &&
				(this.isTabOpened || this.totalProductsCount) &&
				!this.productId
			)
		},

		productId() {
			return this.$route.query.productId
		},

		acceptOnlineOrder() {
			return this.venueInfo.acceptOnlineOrder
		}
	},

	mounted() {
		window.addEventListener('scroll', this.handleScroll)
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},

	methods: {
		handleScroll() {
			if (this.scrollTarget) {
				const targetElement = document.querySelector(this.scrollTarget)

				if (targetElement) {
					const targetPosition = targetElement.getBoundingClientRect().top

					this.visible = targetPosition + this.scrollThreshold < 0
					return
				}
			}

			this.visible = window.scrollY > this.scrollThreshold
		},

		scrollToTop() {
			if (this.scrollTarget) {
				const targetElement = document.querySelector(this.scrollTarget)
				if (targetElement) {
					const rect = targetElement.getBoundingClientRect()
					const scrollTop = window.scrollY
					const elementTop = rect.top + scrollTop - this.offset

					window.scrollTo({
						top: elementTop,
						behavior: 'smooth'
					})
					return
				}
			}

			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.back-to-top {
	display: none;
	position: fixed;
	bottom: 53px;
	right: 30px;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background-color: rgba($light-violet, 0.2);
	border: 1px solid rgba($white, 0.2);
	cursor: pointer;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	z-index: 100;

	@media (min-width: 768px) {
		display: flex;
	}

	&:hover {
		background-color: rgba($light-blue, 0.25);
		transform: translateY(-3px);
	}

	&:active {
		transform: translateY(-1px);
	}

	&::before {
		content: '';
		width: 8px;
		height: 8px;
		border: solid $white;
		border-width: 2px 2px 0 0;
		position: absolute;
		font-size: 0.4em;
		top: calc(50% - 0.4em);
		left: 50%;
		transition: all 0.2s;
		transform: translateX(-50%) rotate(-45deg);
	}

	&.cart-visible {
		bottom: 100px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
